import {Pipe, PipeTransform} from '@angular/core';

const IMAGE_RESIZE_BASE = 'https://wsrv.nl/';

export interface ImageResizeOptions {
  width?: number;
  height?: number;
  quality?: number;
  format?: 'webp' | 'jpg' | 'png' | 'avif';
}

function isRemote(url: string | null | undefined): url is string {
  return !!url && /^https?:\/\//i.test(url);
}

export function resizeImage(url: string | null | undefined, options: ImageResizeOptions = {}): string {
  if (!url) return '';
  if (!isRemote(url)) return url;

  const {width, height, quality = 80, format = 'webp'} = options;

  let source = url;
  try {
    source = decodeURI(url);
  } catch {
    source = url;
  }

  const parts = [`url=${encodeURIComponent(source)}`];
  if (width) parts.push(`w=${width}`);
  if (height) parts.push(`h=${height}`);
  parts.push(`output=${format}`);
  parts.push(`q=${quality}`);
  parts.push('we');

  return `${IMAGE_RESIZE_BASE}?${parts.join('&')}`;
}

function imageSrcset(url: string | null | undefined, widths: number[], options: ImageResizeOptions = {}): string {
  if (!isRemote(url) || !widths?.length) return '';

  return widths
    .map(width => `${resizeImage(url, {...options, width})} ${width}w`)
    .join(', ');
}

@Pipe({name: 'imgResize'})
export class ImageResizePipe implements PipeTransform {
  transform(url: string | null | undefined, width?: number, options?: ImageResizeOptions): string {
    return resizeImage(url, {...(options ?? {}), width});
  }
}

@Pipe({name: 'imgSrcset'})
export class ImageSrcsetPipe implements PipeTransform {
  transform(url: string | null | undefined, widths: number[], options?: ImageResizeOptions): string {
    return imageSrcset(url, widths, options ?? {});
  }
}
